import { Link } from 'react-router-dom';
import LegalPage, { ContactLink, LegalSection } from './legal/LegalPage';

/** Terms of Service, first written 2026-10-27 for the App Store. A draft until someone qualified has read it. */
export default function TermsOfService() {
  return (
    <LegalPage title="Prii Terms of Service" updated="October 27, 2026">
      <p>
        These terms are an agreement between you and Prii (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or
        &ldquo;us&rdquo;) about your use of the Prii app and website. By creating an account or
        using Prii, you agree to them. Our{' '}
        <Link to="/privacy" className="text-primary hover:underline font-medium">
          Privacy Policy
        </Link>{' '}
        explains how we handle your information.
      </p>

      <LegalSection title="Who Can Use Prii">
        <p>
          You must be at least 13 to use Prii. If you are under 18, you need a parent or
          guardian&apos;s permission. Some events are for adults only; it is up to you to meet an
          event&apos;s age rules.
        </p>
      </LegalSection>

      <LegalSection title="Your Account">
        <p>
          Give accurate information and keep your login secure. You are responsible for what happens
          on your account. One person per account, and do not pretend to be someone else.
        </p>
      </LegalSection>

      <LegalSection title="Your Content">
        <p>
          You own what you post: your photo, messages and profile. You give us permission to store,
          display and send it as needed to run Prii, for example showing your messages to your
          group. That permission ends when you delete the content or your account, except for copies
          other people already received, like messages in a chat.
        </p>
      </LegalSection>

      <LegalSection title="Rules">
        <p>Do not use Prii to:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>harass, threaten, stalk or track anyone without their agreement</li>
          <li>
            post anything illegal, hateful, sexually explicit, or that you do not have the right to
            share
          </li>
          <li>spam, scam, or sell tickets or anything else</li>
          <li>
            break, overload, scrape or reverse-engineer Prii, or get into accounts or data that are
            not yours
          </li>
        </ul>
        <p>
          You can report or block a user from their profile. We may remove content or accounts that
          break these rules.
        </p>
      </LegalSection>

      <LegalSection title="Location and Find">
        <p>
          Sharing your location is your choice, and only your group for that event can see it.
          Locations can be wrong or late: GPS, Bluetooth and signal are unreliable in crowds. Do not
          rely on Prii in an emergency. Contact event staff or emergency services instead.
        </p>
      </LegalSection>

      <LegalSection title="Event Information">
        <p>
          Event listings, lineups, set times and maps come from promoters, ticket sellers and
          festival websites, and can change or be wrong. Check with the event before you travel.
          Prii is not affiliated with the events, artists, venues or ticket sellers it lists, and we
          do not sell tickets.
        </p>
      </LegalSection>

      <LegalSection title="Third-Party Services">
        <p>
          Prii links to and embeds other services, like Spotify and ticket sellers. Their own terms
          apply when you use them, and we are not responsible for them.
        </p>
      </LegalSection>

      <LegalSection title="Ending Your Account">
        <p>
          You can delete your account at any time in Settings. We may suspend or close an account
          that breaks these terms or puts other people at risk.
        </p>
      </LegalSection>

      <LegalSection title="Disclaimers">
        <p>
          Prii is provided &ldquo;as is&rdquo; and &ldquo;as available.&rdquo; To the extent the law
          allows, we make no promises that it will always work, be accurate, or be free of errors.
        </p>
      </LegalSection>

      <LegalSection title="Limitation of Liability">
        <p>
          To the extent the law allows, Prii is not liable for indirect, incidental or consequential
          losses, or for what happens at events or between users. Our total liability for any claim
          is limited to $100.
        </p>
      </LegalSection>

      <LegalSection title="Changes">
        <p>
          We may update these terms. We will update the date above, and tell you in the app if a
          change is significant. Using Prii after a change means you accept it.
        </p>
      </LegalSection>

      <LegalSection title="Governing Law">
        <p>These terms are governed by the laws of the State of California, USA.</p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          Questions about these terms? Contact us at <ContactLink />.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
